module.exports = __webpack_public_path__ + "img/switch-off.fe12e010.svg";